import React from "react";
import Layout from "../../components/user/Layout";
import OrderSummary from "../../components/OrderSummary";

const OrderSummaryPage = () => {
  return (
    <>
      <Layout>
        <OrderSummary />
      </Layout>
    </>
  );
};

export default OrderSummaryPage;
